const mediaItems = [
  {
    title: '2026暑期档十大必看电影盘点',
    desc: '为你精选今年暑期最值得期待的院线大片，从动作巨制到温馨喜剧一网打尽',
    duration: '12:35',
    views: '3.2万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20movie%20collage%20style%20with%20warm%20golden%20sunlight%20and%20film%20strip%20elements%2C%20amber%20and%20crimson%20tones%2C%20dramatic%20composition%2C%20film%20poster%20aesthetic%2C%20vibrant%20cinematic%20atmosphere&width=800&height=450&seq=media-summer-movie&orientation=landscape',
  },
  {
    title: '动作片经典场景深度解析',
    desc: '回顾动作电影史上最令人难忘的经典镜头与拍摄幕后故事',
    duration: '08:22',
    views: '2.7万',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20analysis%20style%20with%20explosive%20warm%20orange%20and%20red%20lighting%2C%20cinematic%20composition%2C%20film%20grain%20texture%2C%20dramatic%20contrast%2C%20professional%20film%20analysis%20atmosphere&width=800&height=450&seq=media-action-scene&orientation=landscape',
  },
  {
    title: '喜剧电影推荐：笑到停不下来',
    desc: '精选国内外高分喜剧电影，保证让你从头笑到尾，治愈你的不开心',
    duration: '15:48',
    views: '4.1万',
    image: 'https://readdy.ai/api/search-image?query=Bright%20joyful%20comedy%20film%20recommendation%20style%20with%20warm%20yellow%20and%20golden%20tones%2C%20playful%20cinematic%20composition%2C%20lighthearted%20movie%20poster%20aesthetic%2C%20vibrant%20and%20cheerful%20atmosphere&width=800&height=450&seq=media-comedy-reco&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            精彩影评
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            深度电影解说与推荐，帮你发现更多好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-black/50 backdrop-blur-sm">
                    <i className="ri-play-fill text-white text-xs"></i>
                    <span className="text-white text-xs whitespace-nowrap">{item.duration}</span>
                  </div>
                  <div className="flex items-center gap-1 text-white/80 text-xs">
                    <i className="ri-eye-line"></i>
                    <span className="whitespace-nowrap">{item.views}</span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}